/** Sixense */
import { BydHttpParams } from '@sixense/byd-core-service';
/** Types */
import { ParamsFromObjectType } from '../types/byd-params-from-object.type';
/** Functions */
import { BydIsHttpParam } from './byd-is-http-param.function';

/**
 * Generate new parameters it replaces the value for a parameter.
 *
 * @param filters the filters object
 * @returns BydHttpParams
 */
export function BydGenerateParams<T>(filters: T): BydHttpParams {
  if (filters) {
    let httpParams: BydHttpParams;
    httpParams = new BydHttpParams(<ParamsFromObjectType>{ fromObject: filters });
    for (let i = 0, keys = Object.keys(filters); i < keys.length; i++) {
      const key = keys[i];
      const value = filters[key];
      httpParams = !BydIsHttpParam(value) ? httpParams.delete(keys[i]) : httpParams;
    }
    return httpParams;
  }
}
